import { render } from "./TheMenu.vue?vue&type=template&id=cb295050&scoped=true"
import script from "./TheMenu.vue?vue&type=script&lang=js"
export * from "./TheMenu.vue?vue&type=script&lang=js"

import "./TheMenu.vue?vue&type=style&index=0&id=cb295050&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb295050"]])

export default __exports__